<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <div class="omnica-modal-window__title">Клиенты с одинаковыми данными</div>
        <div class="omnica-modal-window__close" @click="close">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="omnica-popper-target" style="width: 100%;">
            <path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path>
          </svg>
        </div>  
      </div>

      <div class="double-parameters_fqSs7">
        Телефон: {{ phone }}
      </div>

      <div class="container_vCNle table-customer_kgGpZ" v-if="doubleArray && doubleArray.data && doubleArray.data.length > 0">
        <table class="table_AJsNp">
          <colgroup>
            <col width="5%">
            <col width="25%">
            <col width="10%">
            <col width="15%">
            <col width="15%">
            <col width="20%">
            <col width="10%">
          </colgroup>

          <thead>
            <tr>
              <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">№</th>
              <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">ФИО</th>
              <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Заказов</th>
              <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Регистрация</th>
              <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Магазин</th>
              <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Телефоны</th>
              <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in doubleArray.data" :key="index">
              
              <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
                <div class="UiText-text_accent-nhXJ">{{ index + 1 }}</div>
              </td>

              <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
                <div class="priority_w5QV1">
                  {{ item.customer.lastName }} {{ item.customer.firstName }}
                </div>
              </td>

              <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY" style="text-align: center;">
                {{ item.customer.ordersCount }}
              </td>

              <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
                {{ item.customer.createdAt }}
              </td>

              <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
                {{ formatStore(item.customer.site) }}
              </td>

              <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
                <div v-for="(p, pIdx) in item.customer.phones" :key="pIdx">
                  {{ p.number }}
                </div>
              </td>

              <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc UiText-text_uppercase-jshF text_mIYLz teckych">
                <span v-if="isCurrentCustomer(item.customer.phones)">
                  текущий
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else style="padding: 20px; text-align: center;">
        Данных нет
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, required: true },
    phone: { type: String, required: true },     
    doubleArray: { 
      type: Object, // Возвращаем Object, чтобы Vue не ругался
      required: true 
    },
    stores: { type: Array, required: true }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    formatStore(siteCode) {
      if (!siteCode) return '-';
      const store = this.stores.find(el => el.value === siteCode);
      return store ? store.label : siteCode;
    },
    isCurrentCustomer(phones) {
      if (!phones || !this.phone) return false;
      const cleanTarget = this.phone.replace(/\D/g, '');
      return phones.some(p => p.number.replace(/\D/g, '') === cleanTarget);
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  
}


.modal-content {
    background: white;
    padding: 0px;
    border-radius: 5px;
    max-width: 80%;
    max-height: 80%;
    overflow-y: auto;
    position: relative;
    right: 0;
    left: 0;
    z-index: 1040;
    --default-padding: 56px 296px;
    width: 100%;
    min-height: 320px;
    margin: 40px auto;
    border-radius: 0px;
    background: #fafafa;
    max-height: calc(100vh - 80px);
    overflow: hidden;
    margin: 60px auto 40px auto;
    overflow-y: scroll;
    position: relative;
}

.modal-content {
    background: #ffffff;
    width: 100%;
    max-width: 1000px;
    position: relative;
    overflow-y: auto;
    max-height: 85vh;
    border-radius: 8px;
}


/* Фиксированный заголовок с поиском и кнопкой закрытия */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
    border-bottom: 1px solid #dee2e6;
    
    padding: 18px 32px 18px 32px;
}


.omnica-modal-window__close {
    color: #afb9c3;
    height: 32px;
    right: 18px;
    top: 18px;
    width: 32px;
    cursor: pointer;
    transition: 0.3s;
}
.omnica-modal-window__close:hover {
    transform: rotate(180deg);
}
.omnica-modal-window_popup .omnica-modal-window__title {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.33333333;
}

.double-parameters_fqSs7{
    padding: 16px 48px 16px 32px;
    font-weight: bold;
 }
.table-customer_kgGpZ th {
    border-top: 1px solid #dee2e6;
}
.cell_eOMiF {
    background-color: #f9fafb;
    border-bottom: 1px solid #dee2e6;
    color: #8a96a6;
    padding: 12px;
}
.teckych {
    color: #999;
    text-transform:uppercase;
    text-align: center;
}
</style>
